export function initScrollingMarquee() {
    const sections = document.querySelectorAll('.scrollingMarquee');
    if (sections.length === 0) return;

    sections.forEach(section => {
        const leftRows = section.querySelectorAll('.js-marquee-left');
        const rightRows = section.querySelectorAll('.js-marquee-right');

        const initRow = (row) => {
            const content = row.querySelector('.scrollingMarquee__content');
            if (!content) return;

            // Ensure no CSS animation is running
            content.style.animation = 'none';

            let baseWidth = content.offsetWidth;

            // Fill row with enough content to cover screen width + some extra
            const fillRow = () => {
                const rowWidth = row.offsetWidth || window.innerWidth;
                baseWidth = content.offsetWidth;
                
                if (baseWidth === 0) return;

                const initialChildren = Array.from(content.children);
                const targetWidth = rowWidth + baseWidth * 2;
                
                let iterations = 0;
                while (content.offsetWidth < targetWidth && iterations < 50) {
                    initialChildren.forEach(child => {
                        content.appendChild(child.cloneNode(true));
                    });
                    iterations++;
                }
            };

            fillRow();
            
            return { row, content, getBaseWidth: () => baseWidth };
        };

        const leftRowData = Array.from(leftRows).map(initRow).filter(Boolean);
        const rightRowData = Array.from(rightRows).map(initRow).filter(Boolean);

        let currentMovement = 0;

        const updateTarget = () => {
            const rect = section.getBoundingClientRect();
            const viewportHeight = window.innerHeight;

            if (rect.top < viewportHeight && rect.bottom > 0) {
                const totalDistance = viewportHeight + rect.height;
                const currentDistance = viewportHeight - rect.top;
                const scrollPercent = currentDistance / totalDistance;
                
                currentMovement = scrollPercent * 600; // Direct movement, no target/lerp
            }
        };

        const animate = () => {
            leftRowData.forEach(data => {
                const firstItemWidth = data.getBaseWidth();
                if (firstItemWidth === 0) return;

                const x = (currentMovement % firstItemWidth);
                data.content.style.transform = `translateX(-${x}px)`;
            });

            rightRowData.forEach(data => {
                const firstItemWidth = data.getBaseWidth();
                if (firstItemWidth === 0) return;

                const x = (currentMovement % firstItemWidth);
                data.content.style.transform = `translateX(${x - firstItemWidth}px)`; 
            });

            requestAnimationFrame(animate);
        };

        window.addEventListener('scroll', updateTarget, { passive: true });
        window.addEventListener('resize', () => {
            updateTarget();
        });

        updateTarget();
        requestAnimationFrame(animate);
    });
}
